import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full flex flex-col gap-2" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row items-center justify-between h-8" }, [
  /*#__PURE__*/_createVNode("label", { class: "text-sm font-semibold text-gray-lp-300" }, " Nama Area ")
], -1)
const _hoisted_3 = { class: "absolute right-4 text-gray-lp-600 font-medium text-sm" }
const _hoisted_4 = { class: "flex items-center gap-2 text-red-lp-1200 text-sm mt-2 h-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", {
      class: ["relative border rounded-lg px-4 py-2.5 flex items-center", 
        _ctx.validationError
          ? 'border-red-lp-750 focus-within:border-red-lp-700'
          : 'border-gray-lp-400 focus-within:border-gray-lp-600'
      ]
    }, [
      _createVNode("input", {
        type: "text",
        class: "w-full outline-none text-sm placeholder-gray-lp-600 text-black-lp-200 mr-16",
        placeholder: "Nama area",
        value: _ctx.modelValue,
        onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args))),
        onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args)))
      }, null, 40, ["value"]),
      _createVNode("span", _hoisted_3, _toDisplayString(_ctx.modelValue.length) + "/100 ", 1)
    ], 2),
    _withDirectives(_createVNode("div", _hoisted_4, [
      _createVNode(_component_Icons, {
        name: "warning-triangle",
        class: "w-3"
      }),
      _createVNode("span", null, _toDisplayString(_ctx.validationError), 1)
    ], 512), [
      [_vShow, _ctx.validationError]
    ])
  ]))
}